import { AttributesData, Frequency } from "@sportal/api";

export const LOAD_ATTRIBUTES = "[USER_SETTINGS] LOAD_ATTRIBUTES";
export const LOAD_ATTRIBUTES_SUCCESS =
  "[USER_SETTINGS] LOAD_ATTRIBUTES_SUCCESS";
export const LOAD_ATTRIBUTES_FAILURE =
  "[USER_SETTINGS] LOAD_ATTRIBUTES_FAILURE";
export const CHANGE_LANGUAGE_SUCCESS =
  "[USER_SETTINGS] CHANGE_LANGUAGE_SUCCESS";
export const CHANGE_LANGUAGE_FAILURE =
  "[USER_SETTINGS] CHANGE_LANGUAGE_FAILURE";
export const CHANGE_TIMEZONE_SUCCESS =
  "[USER_SETTINGS] CHANGE_TIMEZONE_SUCCESS";
export const CHANGE_TIMEZONE_FAILURE =
  "[USER_SETTINGS] CHANGE_TIMEZONE_FAILURE";
export const CHANGE_TIME_FORMAT_SUCCESS =
  "[USER_SETTINGS] CHANGE_TIME_FORMAT_SUCCESS";
export const CHANGE_TIME_FORMAT_FAILURE =
  "[USER_SETTINGS] CHANGE_TIME_FORMAT_FAILURE";
export const CHANGE_APR_SETTING_SUCCESS =
  "[USER_SETTINGS] CHANGE_APR_SETTING_SUCCESS";
export const CHANGE_APR_SETTING_FAILURE =
  "[USER_SETTINGS] CHANGE_APR_SETTING_FAILURE";
export const UPDATE_EMAIL_ADDRESS_SUCCESS =
  "[USER_SETTINGS] UPDATE_EMAIL_ADDRESS_SUCCESS";
export const UPDATE_EMAIL_ADDRESS_FAILURE =
  "[USER_SETTINGS] UPDATE_EMAIL_ADDRESS_FAILURE";
export const UPDATE_EMAIL_FREQUENCY_SUCCESS =
  "[USER_SETTINGS] UPDATE_EMAIL_FREQUENCY_SUCCESS";
export const UPDATE_EMAIL_FREQUENCY_FAILURE =
  "[USER_SETTINGS] UPDATE_EMAIL_FREQUENCY_FAILURE";
export const LOAD_TIMEZONES_SUCCESS = "[USER_SETTINGS] LOAD_TIMEZONES_SUCCESS";
export const LOAD_TIMEZONES_FAILURE = "[USER_SETTINGS] LOAD_TIMEZONES_FAILURE";
export const CHANGE_ATTRIBUTE = "[USER_SETTINGS] CHANGE_ATTRIBUTE";
export const DISCARD_SCHEDULED_REPORTS_SETTINGS =
  "[USER_SETTINGS] DISCARD_SCHEDULED_REPORTS_SETTINGS";

interface LoadingAttributesAction {
  type: typeof LOAD_ATTRIBUTES;
}

interface LoadAttributesSuccessAction {
  type: typeof LOAD_ATTRIBUTES_SUCCESS;
  payload: AttributesData;
}

interface LoadAttributesFailureAction {
  type: typeof LOAD_ATTRIBUTES_FAILURE;
  payload: object & { code: number | string };
}

export interface ChangeLanguageSuccessAction {
  type: typeof CHANGE_LANGUAGE_SUCCESS;
  payload: string;
}

interface ChangeLanguageFailureAction {
  type: typeof CHANGE_LANGUAGE_FAILURE;
  payload: object & { code: number | string };
}

interface ChangeTimezoneSuccessAction {
  type: typeof CHANGE_TIMEZONE_SUCCESS;
  payload: string;
}

interface ChangeTimezoneFailureAction {
  type: typeof CHANGE_TIMEZONE_FAILURE;
  payload: object & { code: number | string };
}

interface ChangeTimeFormatSuccessAction {
  type: typeof CHANGE_TIME_FORMAT_SUCCESS;
  payload: boolean;
}

interface ChangeTimeFormatFailureAction {
  type: typeof CHANGE_TIME_FORMAT_FAILURE;
  payload: object & { code: number | string };
}

export interface ChangeAPRSettingSuccessAction {
  type: typeof CHANGE_APR_SETTING_SUCCESS;
  payload: boolean;
}

interface ChangeAPRSettingFailureAction {
  type: typeof CHANGE_APR_SETTING_FAILURE;
  payload: object & { code: number | string };
}

export interface UpdateEmailAddressSuccessAction {
  type: typeof UPDATE_EMAIL_ADDRESS_SUCCESS;
  payload: string;
}

interface UpdateEmailAddressFailureAction {
  type: typeof UPDATE_EMAIL_ADDRESS_FAILURE;
  payload: object & { code: number | string };
}

export interface UpdateEmailFrequencySuccessAction {
  type: typeof UPDATE_EMAIL_FREQUENCY_SUCCESS;
  payload: Frequency;
}

interface UpdateEmailFrequencyFailureAction {
  type: typeof UPDATE_EMAIL_FREQUENCY_FAILURE;
  payload: object & { code: number | string };
}

export type AttributesActionTypes =
  | LoadingAttributesAction
  | LoadAttributesSuccessAction
  | LoadAttributesFailureAction
  | ChangeLanguageSuccessAction
  | ChangeLanguageFailureAction
  | ChangeTimezoneSuccessAction
  | ChangeTimezoneFailureAction
  | ChangeTimeFormatSuccessAction
  | ChangeTimeFormatFailureAction
  | ChangeAPRSettingSuccessAction
  | ChangeAPRSettingFailureAction
  | UpdateEmailAddressSuccessAction
  | UpdateEmailAddressFailureAction
  | UpdateEmailFrequencySuccessAction
  | UpdateEmailFrequencyFailureAction;
